var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4629",
    "data-name": "Path 4629",
    d: "M2.625-18a1.871,1.871,0,0,1,1.711,1.112,1.954,1.954,0,0,1-.319,2.019L-.75-9.572V-1.5A1.494,1.494,0,0,1-1.58-.159,1.5,1.5,0,0,1-3.15-.3l-3-2.25a1.49,1.49,0,0,1-.6-1.2V-9.572l-4.769-5.3a1.878,1.878,0,0,1-.319-2.019A1.861,1.861,0,0,1-10.167-18ZM10.5-3A1.5,1.5,0,0,1,12-1.5,1.5,1.5,0,0,1,10.5,0h-6A1.5,1.5,0,0,1,3-1.5,1.5,1.5,0,0,1,4.5-3ZM3-9a1.5,1.5,0,0,1,1.5-1.5h6A1.5,1.5,0,0,1,12-9a1.5,1.5,0,0,1-1.5,1.5h-6A1.5,1.5,0,0,1,3-9Zm7.5-9A1.5,1.5,0,0,1,12-16.5,1.5,1.5,0,0,1,10.5-15h-3A1.5,1.5,0,0,1,6-16.5,1.5,1.5,0,0,1,7.5-18Z",
    transform: "translate(12 18)",
    fill: "#26313b"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilters);
export default __webpack_public_path__ + "static/media/filters.cb6a71fa47fb984a52f65275794c372e.svg";
export { ForwardRef as ReactComponent };